<template>
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M5.32 12.66H4.99C4.62 12.66 4.32 12.96 4.32 13.33C4.32 13.7 4.62 14 4.99 14H5.32C5.69 14 5.99 13.7 5.99 13.33C5.99 12.96 5.69 12.66 5.32 12.66Z"
			fill="#646E87"
		/>
		<path
			d="M2.99 10.66H2.66C2.29 10.66 1.99 10.96 1.99 11.33C1.99 11.7 2.29 12 2.66 12H2.99C3.36 12 3.66 11.7 3.66 11.33C3.66 10.96 3.36 10.66 2.99 10.66Z"
			fill="#646E87"
		/>
		<path
			d="M2.99 12.66H2.66C2.29 12.66 1.99 12.96 1.99 13.33C1.99 13.7 2.29 14 2.66 14H2.99C3.36 14 3.66 13.7 3.66 13.33C3.66 12.96 3.36 12.66 2.99 12.66Z"
			fill="#646E87"
		/>
		<path
			d="M14 0H4.32C3.03 0 1.99 1.05 1.99 2.33V4.66C1.99 5.03 2.29 5.33 2.66 5.33C3.03 5.33 3.33 5.03 3.33 4.66V2.33C3.33 1.78 3.78 1.33 4.33 1.33C4.88 1.33 5.33 1.78 5.33 2.33C5.33 3.25 6.08 4 7 4H12.67V12.67C12.67 13.77 11.77 14.67 10.67 14.67H9.34C8.97 14.67 8.67 14.97 8.67 15.34C8.67 15.71 8.97 16.01 9.34 16.01H10.67C12.51 16.01 14 14.51 14 12.68V4H14.33C15.25 4 16 3.25 16 2.33V2C16 0.9 15.1 0 14 0ZM14.67 2.33H14.66C14.66 2.51 14.51 2.66 14.33 2.66H7C6.82 2.66 6.67 2.51 6.67 2.33C6.67 1.97 6.59 1.63 6.44 1.33H14C14.37 1.33 14.67 1.63 14.67 2V2.33Z"
			fill="#646E87"
		/>
		<path
			d="M5.66 6.67H2.33C1.04 6.67 0 7.72 0 9V13.67C0 14.96 1.05 16 2.33 16H5.66C6.95 16 7.99 14.95 7.99 13.67V9C7.99 7.71 6.94 6.67 5.66 6.67ZM6.66 13.67C6.66 14.22 6.21 14.67 5.66 14.67H2.33C1.78 14.67 1.33 14.22 1.33 13.67V9C1.33 8.45 1.78 8 2.33 8H5.66C6.21 8 6.66 8.45 6.66 9V13.67Z"
			fill="#646E87"
		/>
		<path
			d="M5.32 8.66H2.65C2.28 8.66 1.98 8.96 1.98 9.33C1.98 9.7 2.28 10 2.65 10H5.32C5.69 10 5.99 9.7 5.99 9.33C5.99 8.96 5.69 8.66 5.32 8.66Z"
			fill="#646E87"
		/>
		<path
			d="M5.32 10.66H4.99C4.62 10.66 4.32 10.96 4.32 11.33C4.32 11.7 4.62 12 4.99 12H5.32C5.69 12 5.99 11.7 5.99 11.33C5.99 10.96 5.69 10.66 5.32 10.66Z"
			fill="#646E87"
		/>
	</svg>
</template>

<script>
export default {
	name: 'BillingUsageIcon',
};
</script>
